import { useQuery } from '@tanstack/react-query';

import { productRankingService } from '../api';
import type { ProductRankingData } from '../types';

export const useProductRankingFromSheets = () => {
  return useQuery<ProductRankingData>({
    queryKey: ['product-ranking-sheets'],
    queryFn: () => productRankingService.fetchFromGoogleSheets(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
